/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded link off.
 * @export
 */
export const ICON_LINK_OFF = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.39 11.065L16 12.675V11.065H14.39ZM17 7.06505H13V8.96505H17C18.71 8.96505 20.1 10.355 20.1 12.065C20.1 13.335 19.33 14.435 18.23 14.905L19.63 16.305C21.05 15.425 22 13.855 22 12.065C22 9.30505 19.76 7.06505 17 7.06505ZM2 4.33505L5.11 7.44505C3.29 8.18505 2 9.97505 2 12.065C2 14.825 4.24 17.065 7 17.065H11V15.165H7C5.29 15.165 3.9 13.775 3.9 12.065C3.9 10.475 5.11 9.16505 6.66 8.99505L8.73 11.065H8V13.065H10.73L13 15.335V17.065H14.73L18.74 21.075L20.15 19.665L3.41 2.92505L2 4.33505Z"
      fill="#707070"
    />
  </svg>
);
